// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Offline Indicator Styles
 */

.offline-indicator {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background-color: #f59e0b;
    color: #ffffff;
    padding: 12px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.offline-indicator__content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    max-width: 1200px;
    margin: 0 auto;
}

.offline-indicator__icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
}

.offline-indicator__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.offline-indicator__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.4;
}

.offline-indicator__queue {
    font-size: 12px;
    line-height: 1.4;
    opacity: 0.9;
}

/* Responsive adjustments */
@media (max-width: 640px) {
    .offline-indicator {
        padding: 10px 12px;
    }

    .offline-indicator__content {
        gap: 8px;
    }

    .offline-indicator__icon {
        width: 18px;
        height: 18px;
    }

    .offline-indicator__title {
        font-size: 13px;
    }

    .offline-indicator__queue {
        font-size: 11px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/OfflineIndicator.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/**\n * Offline Indicator Styles\n */\n\n.offline-indicator {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 9999;\n    background-color: #f59e0b;\n    color: #ffffff;\n    padding: 12px 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n    from {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.offline-indicator__content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.offline-indicator__icon {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n}\n\n.offline-indicator__text {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.offline-indicator__title {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 1.4;\n}\n\n.offline-indicator__queue {\n    font-size: 12px;\n    line-height: 1.4;\n    opacity: 0.9;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n    .offline-indicator {\n        padding: 10px 12px;\n    }\n\n    .offline-indicator__content {\n        gap: 8px;\n    }\n\n    .offline-indicator__icon {\n        width: 18px;\n        height: 18px;\n    }\n\n    .offline-indicator__title {\n        font-size: 13px;\n    }\n\n    .offline-indicator__queue {\n        font-size: 11px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
